/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"container":"error_container__83BE2"};